export default __webpack_public_path__ + "static/media/lease-guide-chart-1.a0e02fa3.svg";